import React, {useEffect} from "react"
import About from "../About"
import Banner from "../Banner"
import Footer from "../Footer"
import Header from "../Header"
import EmbedForm from "../EmbedForm"
import Formation from "../Formation"
import ContentLeftOne from "../ContentLeftOne"
import OpportunitesInternationales from "../OpportunitesInternationales"
import Compteurs from "../Compteurs"
import TauxInsertion from "../TauxInsertion"
import Temoignages from "../Temoignages"

const LandingPage = () => {
    useEffect(() => {
        document.documentElement.scrollTop = 0
    }, [])
    return (
        <>
            <Header/>
            <Banner/>
            <About/>
            <EmbedForm/>
            <Formation/>
            <ContentLeftOne/>
            <OpportunitesInternationales/>
            <Temoignages/>
            <Compteurs/>
            <TauxInsertion/>

            <Footer/>
        </>
    )
}

export default LandingPage
